const saltyNationalHolidays = new Set([
  // Cabinet Office published holidays and substitute holidays through 2027.
  '2026-01-01', '2026-01-12', '2026-02-11', '2026-02-23', '2026-03-20',
  '2026-04-29', '2026-05-03', '2026-05-04', '2026-05-05', '2026-05-06',
  '2026-07-20', '2026-08-11', '2026-09-21', '2026-09-22', '2026-09-23',
  '2026-10-12', '2026-11-03', '2026-11-23',
  '2027-01-01', '2027-01-11', '2027-02-11', '2027-02-23', '2027-03-21',
  '2027-03-22', '2027-04-29', '2027-05-03', '2027-05-04', '2027-05-05',
  '2027-07-19', '2027-08-11', '2027-09-20', '2027-09-23', '2027-10-11',
  '2027-11-03', '2027-11-23'
]);

const saltyTokyoParts = (date) => {
  const values = Object.fromEntries(new Intl.DateTimeFormat('en-US', {
    timeZone: 'Asia/Tokyo', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit',
    hourCycle: 'h23'
  }).formatToParts(date).filter((part) => part.type !== 'literal').map((part) => [part.type, Number(part.value)]));
  return values;
};

const saltyDateKey = (date) => date.toISOString().slice(0, 10);
const saltyIsBusinessDay = (date, closedDates) => {
  const day = date.getUTCDay();
  const key = saltyDateKey(date);
  return day !== 0 && day !== 6 && !saltyNationalHolidays.has(key) && !closedDates.has(key);
};

const saltyDispatchEstimate = (now, closedDates = new Set()) => {
  const parts = saltyTokyoParts(now);
  if (parts.year > 2027 || (parts.month === 12 && parts.day >= 25) || (parts.month === 1 && parts.day <= 5)) return null;

  const date = new Date(Date.UTC(parts.year, parts.month - 1, parts.day));
  if (parts.hour >= 12 || !saltyIsBusinessDay(date, closedDates)) date.setUTCDate(date.getUTCDate() + 1);
  while (!saltyIsBusinessDay(date, closedDates)) date.setUTCDate(date.getUTCDate() + 1);
  if (date.getUTCFullYear() > 2027) return null;
  return saltyDateKey(date);
};

const initSaltyDispatch = (root) => {
  root.querySelectorAll('[data-salty-shipping-summary]').forEach((summary) => {
    if (summary.dataset.dispatchReady === 'true') return;
    summary.dataset.dispatchReady = 'true';
    const output = summary.querySelector('[data-salty-dispatch-date]');
    const closedDates = new Set((summary.dataset.closedDates || '').split(/[\s,]+/).filter((date) => /^\d{4}-\d{2}-\d{2}$/.test(date)));
    const update = () => {
      const estimate = saltyDispatchEstimate(new Date(), closedDates);
      if (estimate) {
        const [year, month, day] = estimate.split('-');
        output.textContent = `${year}年${month}月${day}日 より順次発送予定`;
      } else {
        output.textContent = '発送予定日は店舗のお知らせをご確認ください。';
      }
    };
    update();
    const timer = window.setInterval(() => {
      if (!summary.isConnected) window.clearInterval(timer);
      else update();
    }, 60_000);
  });
};

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initSaltyDispatch(document), { once: true });
  } else {
    initSaltyDispatch(document);
  }
  document.addEventListener('shopify:section:load', (event) => initSaltyDispatch(event.target));
}

if (typeof module !== 'undefined') module.exports = { saltyDispatchEstimate };
